// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1i6Oe","content":"GlobalSearch_content__1fbgl"};